import { Request } from '../request';
import { ERegisterType } from 'api/public';
import { EPPAStep } from 'types/ppaOnboarding';

export type TLeadFormStepData = {
    email: string;
    providerId?: number | string;
    specialties?: string[]; // 专业领域，对应services字段
    states?: string; // 州执照，对应licenses字段
    providerCount?: string; // 诊所规模，对应practiceSize字段
    patientsPerMonth?: string; // 每月患者数，对应patientVolume字段
    referralSource?: string; // 推荐来源
    ehrSystemStatus?: string; // EHR系统状态，对应ehrAccess字段
    billingMethod?: string; // 计费/账单方式
    practiceHelpType?: string; // "How can Klarity help your practice" 选择结果
    intent?: string; // Lead intent
    phone?: string; // 电话号码
    step: number; // 当前步骤，从1开始
    utm?: null | {
        utmSource?: string;
        utmMedium?: string;
        utmCampaign?: string;
        utmTerm?: string;
        utmContent?: string;
    };
};

export type TGetLeadFormByEmailInput = {
    email: string;
};

export type TLeadFormDetails = {
    id: number;
    createdAt: string; // ISO日期字符串
    updatedAt: string; // ISO日期字符串
} & TLeadFormStepData;

export type TCheckLeadFormByEmailResponse = {
    providerTypes: ERegisterType[] | null;
    ppv: boolean;
    ppa: boolean;
    leadForm: TLeadFormDetails | null;
    onBoardingStep: EPPAStep | null;
    listedOnKlarity: boolean;
    isListedOnKlarity?: boolean;
};

export const saveLeadFormStep = (data: TLeadFormStepData) =>
    Request.post({
        url: '/schedule-server/public/api/provider/lead-form/saveOrUpdate',
        params: data,
        disableErrorNote: true,
    });

export const getLeadFormByEmail = (data: TGetLeadFormByEmailInput) =>
    Request.get({
        url: `/schedule-server/public/api/provider/lead-form/get/${data.email}`,
        params: {},
        disableErrorNote: true,
    });

export const checkLeadFormByEmail = (data: TGetLeadFormByEmailInput) =>
    Request.get({
        url: `/schedule-server/public/api/provider/lead-form/accountInfo/${data.email}`,
        params: {},
        disableErrorNote: true,
    });

export const getSpecialtyList = () =>
    Request.get({
        url: '/schedule-server/public/api/provider/lead-form/specialty/list',
        params: {},
        disableErrorNote: true,
    });

// 激活 step1：发送 6 位邮箱验证码（存活 10 分钟，同 email 最多 5 次，超限返 1049）
export const sendLeadFormCode = (email: string) =>
    Request.post({
        url: '/schedule-server/public/api/provider/lead-form/send-code',
        params: { email },
        disableErrorNote: true,
    });

// 激活 step1：校验验证码（data=true 通过；1047 过期/不存在，1048 连错 3 次锁定）
export const verifyLeadFormCode = (email: string, code: string) =>
    Request.post({
        url: '/schedule-server/public/api/provider/lead-form/verify-code',
        params: { email, code },
        disableErrorNote: true,
    });
